import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { GeneralObSidebar } from "../Layouts/GeneralObSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";

export class DoctorGeneralObservation extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      bloodPressure: "",
      temp: "",
      pulseRate: "",
      respirationRate: "",
      weight: "",
      height: "",
      BMI: "",
      randomBloodSugar: "",
      urinalysisProteinuria: "",
      chiefComplaint: "",
      doctorNotes: "",
      patientName: localStorage.getItem("currentVisitName"),
    };
  }
  componentDidMount() {
    $(".patientDetails").hide();
    // console.log(localStorage.getItem("currentVisitId"))
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    axios
      .get(this.api_url+""+localStorage.getItem('currentModule')+"/general/main", { headers: headers })
      .then((res) => {
        //   const verified = res.data;
        // console.log(res.data[0]['module'])
        console.log(res.data);

        $(".PatientName").text(
          localStorage.getItem("currentVisitName") + "`s General Observations"
        );

        for (var i = 0; i < res.data.length; i++) {
          console.log(res.data[i]);

          var number = i + 1;
          // console.log()

          let tableinit = res.data;

          // console.log(typeof(table))
          let object = {};
          for (let i = 0; i < tableinit.length; i++) {
            delete tableinit[i]._id;
            delete tableinit[i].timeOfRegistration;
            // tableinit[i].clickEvent = () => this.handleRowClick(tableinit[i]);
          }
          // table = JSON.stringify(table);

          var table = Object.assign(tableinit);

          // alert(table)
          this.TableData = table;
          // console.log(this.TableData);
          this.setState({
            DataLoaded: true,
          });

          // var searchRow = '<tr><td>'+number+'</td> <td>'+res.data[i]['Name']+'</td><td>'+res.data[i]['Age']+'</td><td>'+res.data[i]['Profession']+'</td><td>'+res.data[i]['MaritalStatus']+'</td><td>'+res.data[i]['Address']+'</td><td>'+res.data[i]['Tel ']+'</td><td>'+res.data[i]['Nationality']+'</td><td>'+date+'</td><td>'+time+'</td><td>'+visitNumber+'</td><td>'+serialNumber+'</td><td></td><td></td><td><a className="btn btn-primary startTreatment" id="'+res.data[i]['visitid']+'">Start Treatment</a></td></tr>'
          // $('.searchClass').append(searchRow)
        }

        //   if(res.data['status'])
        //   {
        //     $('.sendModuleSuccess').show()
        //     setTimeout(function (props) {
        //         $('.modal').hide()
        //          // this.props.history.push('/reception/dashboard')
        //      }, 3000);
        //   }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    // Complications = request.json["Complications"],
    // PregnancyDate = request.json["PregnancyDate"],
    // EvolutionAndTreatment = request.json["EvolutionAndTreatment"],

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { Complications, PregnancyDate, EvolutionAndTreatment } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "bloodPressure",
          field: "bloodPressure",
          sort: "asc",
          width: 50,
        },
        {
          label: "temp",
          field: "temp",
          sort: "asc",
          width: 50,
        },
        {
          label: "pulseRate",
          field: "pulseRate",
          sort: "asc",
          width: 50,
        },
        {
          label: "respirationRate",
          field: "respirationRate",
          sort: "asc",
          width: 50,
        },
        {
          label: "weight",
          field: "weight",
          sort: "asc",
          width: 50,
        },
        {
          label: "height",
          field: "height",
          sort: "asc",
          width: 50,
        },
        {
          label: "BMI",
          field: "BMI",
          sort: "asc",
          width: 50,
        },

        {
          label: "randomBloodSugar",
          field: "randomBloodSugar",
          sort: "asc",
          width: 50,
        },
        {
          label: "urinalysisProteinuria",
          field: "urinalysisProteinuria",
          sort: "asc",
          width: 50,
        },
        {
          label: "chiefComplaint",
          field: "chiefComplaint",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };

    const { doctorNotes } = this.state;
    return (
      <div>
        <Headers />
        <GeneralObSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <p className="PatientName"></p>

                <MDBDataTable striped bordered data={tabledata} />
                <div className="col-md-6 p-2">
                  <a href="/general/observations" className="btn btn-primary">
                    Add General Observations
                  </a>
                  <br />
                  {/* <div className="py-1">
                                        <h6 className="text-capitalize" style={fontFamilyNunito}>Doctor`s Notes</h6><textarea rows="6" className="form-control" onChange={this.handleChange} value={doctorNotes} name="doctorNotes" required></textarea>
                                    </div> */}
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default DoctorGeneralObservation;
